var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecovery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#489FE1",
    fillOpacity: 0.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#489FE1",
    strokeOpacity: 0.15,
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5003 22L38.5003 24M38.5003 24L41.5003 27L38.0003 30.5L35.0003 27.5M38.5003 24L35.0003 27.5M30.8903 31.61C31.4066 32.1195 31.8171 32.726 32.098 33.3948C32.379 34.0635 32.5249 34.7813 32.5273 35.5066C32.5297 36.232 32.3887 36.9507 32.1122 37.6213C31.8357 38.2919 31.4293 38.9012 30.9164 39.4141C30.4035 39.9271 29.7942 40.3334 29.1236 40.6099C28.453 40.8864 27.7343 41.0275 27.0089 41.025C26.2835 41.0226 25.5658 40.8767 24.8971 40.5958C24.2283 40.3148 23.6217 39.9043 23.1123 39.388C22.1104 38.3507 21.556 36.9614 21.5686 35.5193C21.5811 34.0772 22.1595 32.6977 23.1793 31.678C24.199 30.6583 25.5785 30.0798 27.0206 30.0673C28.4627 30.0548 29.852 30.6091 30.8893 31.611L30.8903 31.61ZM30.8903 31.61L35.0003 27.5",
    stroke: "#489FE1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecovery);
export default __webpack_public_path__ + "static/media/recovery.ed57208baa979e3bbf7fa457c499d318.svg";
export { ForwardRef as ReactComponent };